<template lang="html" @click="closeAll()">
  <nav class="main-nav" >
    <div class="nav-icons" :class="[`${pageColor}-bg`]"> <!-- the background of the icons depends on the route-->
      <TodoButton :icon="'types'" :label="'rhythms'" :class="[pageColor]" @click="navigate('home')" /> <!-- and the color of the icon as well, when focussed, active of hovered-->
      <TodoButton :icon="'projects'" :label="'projects'" :class="[pageColor]" @click="navigate('projects')" />
      <TodoButton :icon="'timediagrams'" :label="'time'" :class="[pageColor]" @click="navigate('timediagrams')" />
      <TodoButton :icon="'settings'" :label="'settings'" :class="[pageColor]" @click="navigate('settings')" />
      <TodoAddButton class="addButton" :icon="''" :class="[`${pageColor}-bg`]" @show-modal="$emit('show-modal')"/>
    </div>

    <transition>
      <div v-show="show" class="extension" :class="[`${pageColor}-bg`]">
        <TodoButton :icon="'important'" :label="'important'" :class="[pageColor]" @click="navigate('category', 'important')" />
        <TodoButton :icon="'habits'" :label="'habits'" :class="[pageColor]" @click="navigate('category', 'habits')" />
        <TodoButton :icon="'close'" :label="'not-do-dos'" :class="[pageColor]" @click="navigate('category', 'not-to-do')" />
      </div>
    </transition>

  </nav>
</template>

<script>
import TodoButton from '@/components/TodoButton.vue';
import TodoAddButton from '@/components/TodoAddButton.vue';

export default {
  components: {
    TodoButton,
    TodoAddButton,
  },
  data() {
    return {
      show: false,
      onboardingcolor: 'onboardingcolor',
    };
  },
  created() {
    window.addEventListener('click', this.closeAll); // if clicked somewhere on the window close the extended navigation
  },
  computed: {
    activeButton() {
      if (this.$route.name === 'home') return this.onboardingcolor;
      if (this.$route.name === 'timediagrams') return this.onboardingcolor;
      return 'black';
    },
  },
  methods: {
    closeAll(e) {
      if (!this.$el.contains(e.target)) { // sets target
        this.show = false;
      }
    },
    navigate(routeName, option) {
      if (routeName === 'home') { // if route name home extension can be opened and closed
        this.show = !this.show;
      } else {
        this.show = false; // all other buttons will close the extension
      }
      if (this.$route.name === routeName && this.$route.params.option === option) return;
      if (routeName === 'home') {
        this.$router.push({ name: 'home' });
        this.show = !this.show;
      } else if (routeName === 'timediagrams') {
        this.$router.push({ name: 'timediagrams' });
        this.show = false;
      } else if (routeName === 'settings') {
        this.$router.push({ name: 'settings' });
        this.show = false;
      } else if (routeName === 'projects') {
        this.$router.push({ name: 'projects' });
        this.show = false;
      } else if (routeName === 'category') {
        this.$router.push({ name: 'category', params: { option } });
        this.show = true;
      } else {
        this.$router.push({ name: 'home' });
        this.show = !this.show;
      }
    },
  },
  props: {
    pageColor: String,
    icon: String,
  },
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/breakpoints'

.main-nav
  margin: 0
  display: flex
  justify-content: center
  @media $desktop
    justify-content: left
  @media $tablet
    justify-content: left

  .nav-icons
    border-top: 1.5px solid black
    padding-top: 1px
    padding-left: 1px
    align-items: center
    position: fixed
    bottom: 0
    width: 100%
    display: flex
    justify-content: center
    padding-right: 30px !important

    @media $desktopLarge
      margin-left: -875px

    @media $desktop
      margin-left: -517px

    @media $tablet
      width: 70%
      transform: rotate(90deg)
      bottom: auto
      top: 0
      padding: 0
      margin: 0
      margin-top: 372px
      margin-left: -427px
      left: 0

    button
      width:60px
      height:60px

      @media $tablet
        margin-top: 2px
        margin-bottom: 1px
        margin-right: 1px
        transform: rotate(-90deg)
        width: 90px
        height: 90px
        margin-bottom: 36px

      .icon
        margin-bottom: 2px
        border: none
        background-color: transparent
        color: inherit

      .label
        margin-bottom: 2px
        border: none
        background-color: transparent !important

      &:not(:hover):not(:focus)
        color: black

      &:hover, &:focus
        background-color: black

      &:focus
        outline: none
        background-color: black

      &:active
        background-color: black

    .addButton
      position: fixed
      border-radius: 20px;
      bottom: 41px
      z-index: 10
      right:0
      margin-right: 30px
      border:none

      @media $desktopLarge
        left: 605px

      @media $desktop
        left: 260px

      @media $tablet
        margin-right: auto
        right: auto
        left: 160px
        bottom: 108px

      &:focus
        color: #D4CE21
        border: none
        cursor: pointer
        outline: none

      &:active
        color: #D4CE21
        border: none
        outline: none

      &:hover
        color: #D4CE21
        border: none
        outline: none

  .extension
    position: absolute
    align-items: left !important
    border: solid black 1px
    padding: 1px
    width: 183px
    height: 60px
    border-radius: 2px
    margin-bottom: 61px
    left: 0
    margin-right: 85px
    margin-left: 42px
    padding-left: 0px
    bottom: 0

    @media $desktop
      margin-top: 233px

    @media $tablet
      position: absolute
      transform: rotate(0deg)
      top: 0
      width: 276px
      height: 90px
      margin-right: 85px
      margin-top: 237px
      margin-left: 59px
      bottom: auto
      left: 34px !important

    button
      width:60px
      height:60px
      padding: 1px
      margin-left: 1px

      @media $tablet
        padding-top: 1px
        padding-left: 3px
        margin-left: 2px
        transform: rotate(0deg)
        width: 90px
        height: 90px
        margin-bottom: 36px

      &:not(:hover):not(:focus)
        color: black
        background-color: transparent

      &:hover, &:focus
        background-color: black

      &:focus
        outline: none
        background-color: black

      &:active
        background-color: black

    &.v-enter-active,
    &.v-leave-active
      transition: transform 200ms ease, opacity 200ms ease

      &.v-enter,
      &.v-leave-to
        transform: translateX(-60px)
        opacity: 0


</style>
